import { FlowsheetContext } from "@/components/FlowSheetEditor/FlowsheetProvider"
import { LineRecord, NodeState, UnitTagState } from "@/components/FlowSheetEditor/services/modal"
import { EyeOutlined } from "@ant-design/icons"
import { useContext, useEffect, useState } from "react"
import { LazyInput } from "./components/common/LazyInput"
import { createUnitTag, getTagIdByNodeId, getTagNodeOptions } from "@/components/FlowSheetEditor/nodes"
import { useGraphInstance, Node } from "@antv/xflow"

interface UnitTagProps {
  unit: NodeState | LineRecord
}
export const UnitTag = (props: UnitTagProps) => {
  const {unit} = props
  const {tag} = unit
  const {changeCellProps} = useContext(FlowsheetContext)

  const [showTag, setShowTag] = useState(unit.showTag !== false)
  const tagId = getTagIdByNodeId(unit.id)
  const graph = useGraphInstance()

  useEffect(() => {
    setShowTag(unit.showTag !== false)
  }, [unit.showTag])

  const toggleTag = () => {
    const isShow = !showTag;
    changeCellProps(unit.id, {showTag: isShow})
    setShowTag(isShow)
    if (isShow) {
      const cell = graph?.getCellById(tagId)
      if (cell) return;
      const tagOptions = getTagNodeOptions(graph?.getCellById(unit.id)!, graph!)
      graph?.addNode(tagOptions)
    } else {
      const cell = graph?.getCellById(tagId) as Node
      if (cell) {
        const tagData = cell.getData() as UnitTagState
        const angle = cell.getAngle()
        const parentCell = graph?.getCellById(unit.id)
        if (parentCell) {
          parentCell.setData({...parentCell.getData(), tagOption: {...tagData, angle}})
        }
        graph?.removeCell(cell)
      }
    }
  }
  
  const tagToggleStyle = {
    color: showTag ? '#1890ff' : undefined
  }

  return <div style={{paddingRight: 10}} className="flex-center">
    <LazyInput key={unit.id} value={tag} onChange={(value) => {
      changeCellProps(unit.id, {tag: value})
      changeCellProps(tagId, {text: value})
    }}/>
    <EyeOutlined className="ml-1" style={tagToggleStyle} onClick={toggleTag} />
  </div>
}